// extracted by mini-css-extract-plugin
module.exports = {"recos":"_A-z","productCardOverride":"aB-z"};